define(["underscore", "client/client-extensions/composite-result-properties-enrichment-handler"], function(
  _,
  CompositeResultPropertiesEnrichmentHandler
) {
  function CompositeResultPropertiesEnrichmentHandlerFactoryV1(getFactories) {
    this._getFactories = getFactories;
  }

  _.extend(CompositeResultPropertiesEnrichmentHandlerFactoryV1.prototype, {
    createHandler: function(options) {
      return new CompositeResultPropertiesEnrichmentHandler(this._getHandlers(options));
    },

    _getHandlers: function(options) {
      return _.reduce(
        (this._getFactories && _.isFunction(this._getFactories) && this._getFactories()) || [],
        function(handlers, factory) {
          try {
            handlers.push(factory && _.isFunction(factory.createHandler) && factory.createHandler(options));
          } catch (error) {
            if (console && console.warn) {
              console.warn("Failed to create handler, skipping.", error);
            }
          }
          return handlers;
        },
        []
      );
    }
  });

  return CompositeResultPropertiesEnrichmentHandlerFactoryV1;
});
